<template>
  <div class="quad-viz-pure">
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>1° = 60' | 2π rad = 360°$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <g transform="translate(150, 180)">
             <!-- Axis -->
             <line x1="0" y1="0" x2="150" y2="0" stroke="#888" stroke-width="2" />
             
             <!-- Terminating side -->
             <line x1="0" y1="0" :x2="lineX" :y2="lineY" stroke="#00d2ff" stroke-width="4" marker-end="url(#angle-arr)" />
             
             <!-- Angle Arc -->
             <path :d="arcPath" fill="none" stroke="#ffd700" stroke-width="2" />
             
             <!-- Complementary/Supplementary indicators -->
             <g v-if="showGuides">
                <line x1="0" y1="0" x2="0" y2="-120" stroke="rgba(255,255,255,0.05)" stroke-dasharray="4" />
                <line x1="0" y1="0" x2="-120" y2="0" stroke="rgba(255,255,255,0.05)" stroke-dasharray="4" />
             </g>

             <circle cx="0" cy="0" r="4" fill="#fff" />
          </g>

          <defs>
             <marker id="angle-arr" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
                <path d="M0,0 L6,3 L0,6 Z" fill="#00d2ff" />
             </marker>
          </defs>
        </svg>
      </div>

      <div class="bottom-controls">
        <div class="discovery-note" v-latex>
          <p><strong>角：</strong>由两条有公共端点的射线组成的图形。
           <strong>锐角</strong>(<90°)、<strong>直角</strong>(=90°)、<strong>钝角</strong>(>90°)、<strong>平角</strong>(=180°)、<strong>周角</strong>(=360°)。角度是衡量旋转程度的基本单位。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AngleViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      angle: 45,
      showGuides: true
    }
  },
  computed: {
    rad() { return -this.angle * Math.PI / 180; },
    lineX() { return 120 * Math.cos(this.rad); },
    lineY() { return 120 * Math.sin(this.rad); },
    typeLabel() {
      if (this.angle === 0) return '始边';
      if (this.angle < 90) return '锐角';
      if (this.angle === 90) return '直角';
      if (this.angle < 180) return '钝角';
      if (this.angle === 180) return '平角';
      if (this.angle === 360) return '周角';
      return '优角';
    },
    typeColor() {
      if (this.angle === 90) return '#2ed573';
      if (this.angle > 90) return '#ff4757';
      return '#00d2ff';
    },
    arcPath() {
      const r = 40;
      const x = r * Math.cos(this.rad);
      const y = r * Math.sin(this.rad);
      const largeArc = this.angle > 180 ? 1 : 0;
      return `M ${r} 0 A ${r} ${r} 0 ${largeArc} 0 ${x} ${y}`;
    }
  }
}
</script>

<style scoped lang="scss">
.angle-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #010205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.hud-top { 
  display: flex; justify-content: space-between; padding: 15px; position: absolute; width: 100%;
  .type-tag { padding: 4px 10px; border-radius: 4px; font-size: 0.7rem; color: #fff; font-weight: bold; }
}
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 10px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>